var _style, _defs, _defs2, _defs3, _defs4, _defs5, _path, _rect, _rect2, _defs6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs7, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs8, _path35, _path36, _defs9, _path37, _path38, _defs10, _path39, _path40, _defs11, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "441.8px",
    height: "400.9px",
    viewBox: "0 0 441.8 400.9",
    style: {
      enableBackground: "new 0 0 441.8 400.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000114063567506069960430000003591814184354239665_);}\n\t.st1{clip-path:url(#SVGID_00000146458766492932683760000017355772774410211224_);}\n\t.st2{opacity:0.42;}\n\t.st3{clip-path:url(#SVGID_00000160894143392572250230000016428620853495747225_);}\n\t.st4{clip-path:url(#SVGID_00000118398119042709354050000007021942742364539278_);}\n\t.st5{fill:url(#Rectangle_13_00000072961571471743472260000012446340473480975014_);}\n\t.st6{opacity:0.43;}\n\t.st7{clip-path:url(#SVGID_00000059302826236512900170000000801644182133281725_);}\n\t.st8{fill:#CEE5ED;}\n\t.st9{fill:#AAC6CE;}\n\t.st10{fill:#85B0BA;}\n\t.st11{clip-path:url(#SVGID_00000160901029101964517520000011332576196632579772_);}\n\t.st12{fill:#3E8CCC;}\n\t.st13{fill:#1E394C;}\n\t.st14{fill:#62BDF4;}\n\t.st15{fill:#34648C;}\n\t.st16{fill:#67B8EF;}\n\t.st17{opacity:0.25;}\n\t.st18{clip-path:url(#SVGID_00000093148148023475468960000002929778693439930505_);}\n\t.st19{fill:#F2BF75;}\n\t.st20{fill:#0F2A3F;}\n\t.st21{fill:#EA9249;}\n\t.st22{fill:#80A9B2;}\n\t.st23{opacity:0.67;}\n\t.st24{clip-path:url(#SVGID_00000067225702798836335300000009744086580172614587_);}\n\t.st25{clip-path:url(#SVGID_00000028319472746044589940000013498435463488392364_);}\n\t.st26{opacity:0.29;}\n\t.st27{clip-path:url(#SVGID_00000152226173342919269330000008010981464250323388_);}\n\t.st28{opacity:0.48;}\n\t.st29{clip-path:url(#SVGID_00000158029064341409208880000012701636515014226829_);}\n\t.st30{fill:#2173AA;}\n\t.st31{fill:#1A3651;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 10,
    y: 9.1,
    width: 421.8,
    height: 382.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148620859066774951880000002704133403036751277_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    style: {
      clipPath: "url(#SVGID_00000148620859066774951880000002704133403036751277_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172442382245682726020000003621132081660212138_",
    x: 10,
    y: 9.1,
    width: 421.8,
    height: 382.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018951850358024742320000009914819715389495963_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172442382245682726020000003621132081660212138_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    style: {
      clipPath: "url(#SVGID_00000018951850358024742320000009914819715389495963_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    transform: "translate(18.184 5.018)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000213230181339295910000004860430947842090395_",
    x: 2.6,
    y: 7,
    width: 400.3,
    height: 370.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021116706161044311790000011139989354281683618_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000213230181339295910000004860430947842090395_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    style: {
      clipPath: "url(#SVGID_00000021116706161044311790000011139989354281683618_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000104708214940879807510000009523911487733594752_",
    d: "M87.5,377.9h230.4 c51.4-35.4,85-93.7,85-159.8C402.9,110.1,313.3,7,202.8,7S2.6,110.1,2.6,218.1C2.6,284.2,36.2,342.5,87.5,377.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010284342749324680690000006280126442326011313_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104708214940879807510000009523911487733594752_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    style: {
      clipPath: "url(#SVGID_00000010284342749324680690000006280126442326011313_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_13_00000011033233939723121020000000114444024679785102_",
    gradientUnits: "userSpaceOnUse",
    x1: -118.956,
    y1: -19.009,
    x2: -118.9524,
    y2: -19.009,
    gradientTransform: "matrix(674.824 0 0 625.375 80266.1328 12080.2031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    style: {
      stopColor: "#F8FBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    style: {
      stopColor: "#E5F3FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#C6E4F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    style: {
      stopColor: "#9CD0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67B8EF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 2.6,
    y: 7,
    style: {
      fill: "url(#Rectangle_13_00000011033233939723121020000000114444024679785102_)"
    },
    width: 400.3,
    height: 370.9
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    transform: "translate(0 617.372)",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114759215330874828740000012000587598437014715_",
    x: 10,
    y: -242.1,
    width: 421.8,
    height: 16.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176005930246518007420000004661426235425830020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114759215330874828740000012000587598437014715_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    style: {
      clipPath: "url(#SVGID_00000176005930246518007420000004661426235425830020_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "st8",
    d: "M431.8-233.8c0-4.6-94.4-8.3-210.9-8.3S10-238.4,10-233.8c0,4.6,94.4,8.3,210.9,8.3 S431.8-229.2,431.8-233.8"
  }))))))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 142.4,
    y: 283.6,
    className: "st9",
    width: 9.6,
    height: 91.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    x: 142.4,
    y: 283.6,
    className: "st10",
    width: 9.6,
    height: 12.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168079839672740220180000002922271639131245502_",
    x: 10,
    y: 9.1,
    width: 421.8,
    height: 382.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151514128884349577750000006906810872724526768_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168079839672740220180000002922271639131245502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    style: {
      clipPath: "url(#SVGID_00000151514128884349577750000006906810872724526768_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "st9",
    d: "M189,375.3h-80.4c-3.1,0-5.5,2.5-5.5,5.5l0,0v2.8h91.5v-2.8 C194.6,377.8,192,375.3,189,375.3L189,375.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "st9",
    d: "M124.6,283.6h66.5c-24.2-8.7-14.8-90.6-10.3-121.5c0.8-5.7-3.1-10.9-8.8-11.7 c-0.5-0.1-1-0.1-1.5-0.1h-44.3c-9,0-16.7,6.7-18,15.7c-3.9,28.2-10,86.7,2.1,109.3C113.1,280.4,118.5,283.6,124.6,283.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "st12",
    d: "M134.3,55.7c0-25.8-20.9-46.6-46.6-46.6S41.1,29.9,41.1,55.7s20.9,46.6,46.6,46.6l0,0 C113.4,102.3,134.3,81.4,134.3,55.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    className: "st8",
    d: "M125.8,55.7c0-21-17.1-38-38-38s-38,17.1-38,38s17.1,38,38,38S125.8,76.7,125.8,55.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    className: "st12",
    d: "M76.9,68.7c-1.3,0-2.4-1.1-2.4-2.4c0-0.7,0.2-1.2,0.7-1.7l9.8-9.9V28.6 c0-1.3,1.1-2.4,2.4-2.4c1.3-0.1,2.4,1.1,2.4,2.4v0.1v27.1c0,0.7-0.2,1.2-0.7,1.7L78.6,67.9C78.1,68.4,77.6,68.7,76.9,68.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    className: "st13",
    d: "M92.7,55c0-3-2.4-5.4-5.4-5.4S81.8,52,81.8,55c0,3,2.4,5.4,5.4,5.4S92.7,58,92.7,55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    className: "st14",
    d: "M353.1,99.1h-79.5c-4.1,0-7.4,3.3-7.4,7.4l0,0v35.9c0,4.1,3.3,7.4,7.4,7.4l0,0h5.5v8.7 c0,0.7,0.7,1.4,1.4,1.4c0.3,0,0.7-0.2,0.9-0.3l10.7-9.7H353c4.1,0,7.4-3.3,7.4-7.4l0,0v-35.9 C360.5,102.3,357.2,99.1,353.1,99.1L353.1,99.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    className: "st15",
    d: "M297.2,124.9c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 S297.2,123.1,297.2,124.9L297.2,124.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    className: "st15",
    d: "M317.2,124.9c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C315.8,121.6,317.2,123.1,317.2,124.9L317.2,124.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    className: "st15",
    d: "M335.9,124.9c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 S335.9,123.1,335.9,124.9L335.9,124.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    className: "st16",
    d: "M92.7,195.3c0-8.8-6.2-17.6-13.8-17.6S65,186.6,65,195.3c0,8.8,6.2,15.9,13.8,15.9 S92.7,204.1,92.7,195.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    transform: "translate(110.062 284.441)",
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000159453214374519544730000015029381275259974539_",
    x: -34.8,
    y: -106.7,
    width: 17.4,
    height: 33.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073702284737770523350000008917568376603655573_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159453214374519544730000015029381275259974539_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    style: {
      clipPath: "url(#SVGID_00000073702284737770523350000008917568376603655573_)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    className: "st15",
    d: "M-31.2-106.7c-1.2,0-2.4,0.2-3.6,0.7c5.9,2.2,10.2,9.5,10.2,16.9 c0,7.4-4.4,13.5-10.2,15.4c1.1,0.3,2.4,0.6,3.6,0.6c7.6,0,13.8-7.1,13.8-15.9S-23.6-106.7-31.2-106.7"
  }))))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    className: "st8",
    d: "M63,205.7l2.4,22.4c0.3,2.8,2.7,5,5.5,5h14.3c2.8,0,5.2-2.1,5.5-5l2.4-22.4 c0.2-1.1-0.7-2.1-1.8-2.3c-0.1,0-0.2,0-0.2,0H65.1c-1.1,0-2,0.9-2,2C63,205.6,63,205.7,63,205.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    className: "st9",
    d: "M65.1,206.8h26.2c0.7,0,1.5,0.5,1.8,1.1l0.2-2.2c0.2-1.1-0.7-2.1-1.8-2.3 c-0.1,0-0.2,0-0.2,0H65.1c-1.1,0-2,0.9-2,2c0,0.1,0,0.2,0,0.2l0.2,2.2C63.7,207.2,64.3,206.8,65.1,206.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    className: "st9",
    d: "M91.3,203.4h-9.1c1.1,0,2,0.9,2,2c0,0.1,0,0.2,0,0.2l-2.4,22.5c-0.3,2.8-2.7,5-5.5,5h9.1 c2.8,0,5.2-2.1,5.5-5l2.4-22.4c0.2-1.1-0.7-2.1-1.8-2.3C91.5,203.4,91.4,203.4,91.3,203.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    className: "st19",
    d: "M205.9,361.7l-1,6.5l5,6.3l12.5-6.1l1.4-5.9l-15.6-2.4L205.9,361.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    className: "st13",
    d: "M216,382.6l1.3-1.6c0.2-0.2,0.6-0.3,0.8-0.1l0.1,0.1l1.3,1.5c0.5,0.7,1.3,1,2.1,1 l29.1-0.5c0.7-0.6,0.7-1.5,0.1-2.2c-4.2-4.3-27.2-11.7-28.4-12.4c-1.1-0.7-8.1,4.8-17.5-0.2c0,0-1.5,7.3-1.7,12 c-0.1,1.9,1.3,3.4,3.2,3.5c0.1,0,0.2,0,0.2,0l7.4-0.2C214.8,383.6,215.5,383.2,216,382.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    className: "st13",
    d: "M152.5,252.1c0,0-12.1,13.3,10,27.9c15.5,10.2,27.7,7.1,37.5,13.3c2.3,1.5,4,3.6,4.1,6.3 l0.5,62.4l1.2,0.6c5.9,2.9,12.8,3,18.6,0.2l8.8-71.2c0.3-4.9-2.4-9-5.4-12.9c-16.9-21.5-46.8-28.8-54.5-30.1 C163.7,246.9,152.5,252.1,152.5,252.1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    className: "st19",
    d: "M157.8,361.7l-1.1,6.5l4.9,6.4l12.6-5.9l1.5-5.9l-15.5-2.6L157.8,361.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    className: "st13",
    d: "M167.6,382.7l1.3-1.5c0.2-0.2,0.6-0.3,0.8-0.1l0.1,0.1l1.3,1.5c0.5,0.7,1.3,1,2.1,1 l29.1-0.1c0.7-0.6,0.7-1.5,0.1-2.2c-4.2-4.4-27.1-12.1-28.2-12.8c-1.1-0.7-8.2,4.7-17.5-0.4c0,0-1.6,7.2-1.9,12 c-0.2,1.9,1.2,3.4,3.1,3.6c0.1,0,0.2,0,0.2,0h7.4C166.4,383.7,167.2,383.3,167.6,382.7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    className: "st13",
    d: "M115.9,240.5c0,0-14.6,16.3,6.5,34.7c14.9,12.9,28.1,7.4,37.5,15.3 c2.2,1.9,3.7,4.4,3.5,7.2l-6.7,63.5l0.5,0.3c5.9,3.8,13.3,4.3,19.5,1.3l16.6-66.9c1.1-5.1-1.1-9.8-3.8-14.3 c-14.7-25-37.7-39.9-45.5-42.4C133.8,236.2,115.9,240.5,115.9,240.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    className: "st20",
    d: "M196.6,291.4c-1.1-0.5-2.3-0.9-3.4-1.2c-0.7-3-2.1-5.9-3.7-8.6 c-6.7-11.2-15.1-21.1-25.1-29.5c5.3-0.9,8-2,9.4-3.5c5.4,1,10.7,2.4,15.9,4.3C196.8,264.9,196.8,284.5,196.6,291.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    className: "st8",
    d: "M155.2,154.1c0,0-21.1-2.8-29.9,13.7c-8.8,16.4-21.9,80.9-10.4,82.8 c5,0.9,18.6,4.3,33.6,3.2c20.6-1.5,25.1-3.4,26.6-7.3l13.1-60.1c0.3-8.3-3.4-16.2-10-21.2 C167.7,157.2,155.2,154.1,155.2,154.1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    className: "st9",
    d: "M188.1,181.1c0,0,0.2,36.2,11.6,38.4c11.4,2.2,41.7,1.5,41.7,1.5v11.5h-65L188.1,181.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    className: "st21",
    d: "M172.4,164.7l2.5-12.8l-16.5-12.7l-3.2,15.1C155.2,154.4,160.4,177.4,172.4,164.7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    className: "st13",
    d: "M193.6,127.5c0,0-8.7,4.2-21.4-3.5c0,0-2.9,5.3-11.5,10.1c0,0-4.5-7.4-7-1.9 c-0.7,1.4-1.1,2.9-1.1,4.6c-8-10.3-2.4-23.9,5.1-31.2c7.1-7,22.4-4.2,31.9-0.3c10.2,4.1,12-3,12-3 C214.3,120.1,193.6,127.5,193.6,127.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    className: "st19",
    d: "M160.7,134c0,0-4.5-7.4-7-1.9c-3.1,6.7,0.4,11,4.6,11c0,0,3.3,17.6,19.4,16.3 s18.5-27.2,15.9-32c0,0-8.7,4.2-21.4-3.5C172.1,124,169.2,129.3,160.7,134"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    className: "st8",
    d: "M300.5,175.1h-67.3c-3.3,0-6.2,2.4-6.8,5.6l-8.9,43.9H299l8.4-41.1 c0.7-3.7-1.7-7.5-5.4-8.2C301.5,175.2,301,175.1,300.5,175.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    className: "st22",
    d: "M298.7,224.6H187.4c-1.9,0-3.3,1.5-3.3,3.3v1.1c0,1.9,1.5,3.3,3.3,3.3h111.3 c1.9,0,3.3-1.5,3.3-3.3v-1.1C302,226.2,300.6,224.6,298.7,224.6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    className: "st9",
    d: "M298.7,224.6h-82.2c1.9,0,3.3,1.5,3.3,3.3v1.1c0,1.9-1.5,3.3-3.3,3.3h82.2 c1.9,0,3.3-1.5,3.3-3.3v-1.1C302,226.2,300.6,224.6,298.7,224.6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    className: "st8",
    d: "M191,222.3c-13.1-1.5-49.9-5.3-56.2-5.9c-8-0.8,9.3-32.9,11.2-43.8 c1.9-10.9-6.4-11.4-6.4-11.4c-4.7-0.6-9.8,0-14.2,6.7c-8.9,13.6-18.9,53.3-13.7,63.2c0.7,1.1,1.9,1.9,3.2,1.9h76.3L191,222.3 L191,222.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    className: "st9",
    d: "M191,222.3c0,0-47.3-3.3-57.6-4.6c-7.9-1.1,8.6-33.9,10.5-44.9s-6.6-10.5-6.6-10.5 c-2.5-0.2-5,0-7.4,0.7c3.2-2.1,6.5-2.2,9.7-1.9c0,0,8.4,0.4,6.4,11.4s-16.7,42.4-11.7,43.6 C140.5,217.6,177.9,220.8,191,222.3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    className: "st19",
    d: "M191,232.9h17.6c0.9,0,1.7-0.7,1.7-1.7c0-0.3-0.1-0.7-0.2-0.9c-1.6-2.5-4.3-6.1-6.2-6.7 c-1.1-0.3-9.8-0.1-12.8,0.3L191,232.9L191,232.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    transform: "translate(270.371 199.723)",
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016077712052447204500000003592064736580691630_",
    x: -100,
    y: -72.2,
    width: 24.1,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175287751850730948520000004214128534171674254_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016077712052447204500000003592064736580691630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    style: {
      clipPath: "url(#SVGID_00000175287751850730948520000004214128534171674254_)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    className: "st21",
    d: "M-76.8-72.2c-1.3,0.5-2.6,0.9-4,1c-0.2,1.2-0.6,3.5-0.8,5.7 c-0.3,3.1,1.2,12.8,0.3,12.8c-1,0-2,0-2.9-0.1c0,0-1.5,13.9-15.4,11.7c-0.2,0-0.2,0-0.3-0.1c2.4,0.8,4.9,1.1,7.4,0.9 C-76.5-41.5-74.1-67.4-76.8-72.2"
  }))))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    className: "st16",
    d: "M396,329.7c0,0,22.2-11,16.2-27.7c-6-16.7-9.8-17.4,1.8-26.8c11.5-9.4,28.2-33,7.1-34.8 c-21.1-1.8-20.1,26.3-37.6,30.2C365.9,274.5,356.3,347.9,396,329.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    transform: "translate(621.487 389.819)",
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000117655854889660605940000005142564984822073014_",
    x: -242.9,
    y: -149.6,
    width: 52.6,
    height: 92.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067934203258431461120000008895455235279579543_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117655854889660605940000005142564984822073014_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    style: {
      clipPath: "url(#SVGID_00000067934203258431461120000008895455235279579543_)"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    className: "st15",
    d: "M-242.9-58.5c4.2,2,10,1.8,17.5-1.6c0,0,22.2-11,16.2-27.7s-9.8-17.4,1.8-26.8 s28.2-33,7.1-34.8c-1.9-0.2-3.7-0.1-5.6,0.3c5.9,2.4,11.9,7.4,4.2,16.4c-12.8,15.1-19.5,20.4-18,30.2 C-218.4-93-219.3-71.4-242.9-58.5"
  }))))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    className: "st16",
    d: "M358.5,329.1c0,0-19.5-0.7-18.5-14.7c1.1-14,1.6-14.6-10.7-19 c-21.6-7.8-4.6-49.4,13.2-23.3c12.3,18.1,17.6,14.1,25.5,15.4C376,289,393.4,335.3,358.5,329.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    transform: "translate(523.805 429.143)",
    className: "st26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076598746872647392630000018398908024434859938_",
    x: -203.1,
    y: -165.6,
    width: 54.4,
    height: 65.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016755463764462240190000007369526858609985670_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076598746872647392630000018398908024434859938_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    style: {
      clipPath: "url(#SVGID_00000016755463764462240190000007369526858609985670_)"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    className: "st15",
    d: "M-155.8-141.6c-8-1.5-13.3,2.7-25.5-15.4c-9.3-13.7-18.3-8.8-21.8,0.1 c5.2-1.6,13.1-2.5,14.1,5.9c1.3,11,26.9,29,26.4,51.4c0.3,0,0.7,0.1,1,0.1c3.7-9.8,8.7-22.6,12.8-33.5 C-151-137.8-153.7-141.2-155.8-141.6"
  }))))))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    className: "st15",
    d: "M362.9,328.4c0,0-24.2-23.7-15.9-27.7c8.3-4.1,24.5,9,15.4-5c-9-14.1-19.6-36.1-7.1-32.6 c12.5,3.5,13.4,7.2,11.9-9.2c-2-21.2,9.8-32.2,21.1-25.3c11.2,6.9-9.6,53.7-1.9,48.7s14.1-9.3,15.7-3.2 c1.5,6.2-22.1,30.2-13.3,26.1c10.9-5,12.5,4,9,9.6C394.4,315.4,380,348.7,362.9,328.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    transform: "translate(604.506 366.74)",
    className: "st28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116236925685029462930000011705418786987435429_",
    x: -236,
    y: -140.1,
    width: 33.7,
    height: 108.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161633045015938824580000009486719026829170834_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116236925685029462930000011705418786987435429_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    style: {
      clipPath: "url(#SVGID_00000161633045015938824580000009486719026829170834_)"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    className: "st13",
    d: "M-206.7-56.9c3.5-5.6,1.9-14.6-9-9.6c-8.8,4.1,14.9-20,13.3-26.1 c-1.6-6.1-8-1.9-15.7,3.2s13-41.8,1.9-48.7c-5.2-3.3-10.5-2.5-14.6,1.2c5.8,1.4,10.4,6.1,7.2,18.6 c-6.8,26.7-11,48.9,1.5,42.4c11.7-6.1-13.6,22.1-13.8,42.5C-221.5-25.1-209.8-51.9-206.7-56.9"
  }))))))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    className: "st8",
    d: "M346.2,331.3l4.7,42.4c0.6,5.3,5,9.3,10.4,9.3h27c5.4,0,9.8-4,10.4-9.3l4.7-42.4 c0.2-2.1-1.3-4.1-3.4-4.3c-0.2,0-0.3,0-0.4,0h-49.5c-2.1,0-3.9,1.7-3.9,3.9C346.2,331,346.2,331.1,346.2,331.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    className: "st9",
    d: "M399.5,326.9h-17.2c2.2,0,3.9,1.7,3.9,3.9c0,0.2,0,0.3,0,0.4l-4.7,42.4 c-0.6,5.3-5,9.3-10.4,9.3h17.2c5.4,0,9.8-4,10.4-9.3l4.7-42.4c0.2-2.1-1.3-4.1-3.4-4.3C399.8,326.9,399.7,326.9,399.5,326.9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    className: "st12",
    d: "M346.9,232.8H56.7c-3.3,0-5.9,2.6-5.9,5.9l0,0v1.9c0,3.3,2.6,5.9,5.9,5.9l0,0h290.2 c3.3,0,5.9-2.6,5.9-5.9l0,0v-1.9C352.9,235.4,350.2,232.8,346.9,232.8L346.9,232.8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    className: "st30",
    d: "M346.9,232.8H56.7c-3.3,0-5.9,2.6-5.9,5.9l0,0v1.9c0,0.6,0.1,1.2,0.3,1.8 c0.7-2.4,3-4.1,5.6-4.1h290.2c2.6,0,4.8,1.7,5.6,4.1c0.2-0.6,0.3-1.2,0.3-1.8v-1.9C352.9,235.4,350.2,232.8,346.9,232.8 L346.9,232.8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    className: "st15",
    d: "M148.5,383.2h-9.7L71.3,246.6H81L148.5,383.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    className: "st15",
    d: "M41.7,383.2h9.7l67.5-136.7h-9.7L41.7,383.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    className: "st15",
    d: "M357.4,383.2h-9.8l-67.5-136.7h9.8L357.4,383.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    className: "st15",
    d: "M250.6,383.2h9.7l67.5-136.7h-9.7L250.6,383.2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    className: "st31",
    d: "M83.7,252l-2.7-5.4h-9.7L74,252H83.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    className: "st31",
    d: "M116.2,252l2.7-5.4h-9.7l-2.7,5.4H116.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    className: "st31",
    d: "M292.6,252l-2.7-5.4h-9.8l2.7,5.4H292.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    className: "st31",
    d: "M325,252l2.7-5.4h-9.7l-2.7,5.4H325z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/login_img.c0381913c9d8cc6607f070e282307c44.svg";
export { ForwardRef as ReactComponent };